export const yotpoCases = {
  case_1: {
    prechatDetails: [
      {
        label: "Topic",
        value: "Please select",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "First Name",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Last Name",
        value: "Aviram",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Email",
        value: "aviram7168@gmail.com",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Product Line",
        value: "SMS",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "Reply to Email",
        value: "aviram7168@gmail.com",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Submitter Email",
        value: "aviram7168@gmail.com",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Requester Name",
        value: "Aviram",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Web Email",
        value: "aviram7168@gmail.com",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Is HT",
        value: false,
        entityMaps: [],
        transcriptFields: ["Is_HT__C"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "Is LT",
        value: true,
        entityMaps: [],
        transcriptFields: ["Is_LT__C"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "Is Free",
        value: false,
        entityMaps: [],
        transcriptFields: ["Is_Free__c"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "Origin",
        value: "Live Chat",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "App Key",
        value: "10s3u7Www6MgonmagjIK3HznfKq2O5yv5XCn8ny9",
        entityMaps: [],
        transcriptFields: ["App_Key__c"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "Chat Group",
        value: "UGC Growth",
        entityMaps: [],
        transcriptFields: ["Chat_Group__c"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "agencyId",
        entityMaps: [],
        transcriptFields: ["Partner_Account__c"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "Page URL",
        value: "https://email-and-sms.yotpo.com/",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "CTTopic",
        entityMaps: [],
        transcriptFields: ["Topic__c"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "eswLiveAgentDevName",
        value: "EmbeddedServiceLiveAgent_Parent04I3W0000004C9wUAE_17bc8e835e7",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "hasOnlyExtraPrechatInfo",
        value: false,
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
    ],
    prechatEntities: [
      {
        entityName: "Contact",
        showOnCreate: true,
        linkToEntityName: "Case",
        linkToEntityField: "ContactId",
        saveToTranscript: "ContactId",
        entityFieldsMaps: [
          {
            fieldName: "FirstName",
            label: "First Name",
            doFind: true,
            isExactMatch: true,
            doCreate: false,
          },
          {
            fieldName: "LastName",
            label: "Last Name",
            doFind: true,
            isExactMatch: true,
            doCreate: false,
          },
          {
            fieldName: "Email",
            label: "Email",
            doFind: true,
            isExactMatch: true,
            doCreate: false,
          },
        ],
      },
      {
        entityName: "Case",
        showOnCreate: true,
        saveToTranscript: "CaseId",
        entityFieldsMaps: [
          {
            fieldName: "Topic__c",
            label: "Topic",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Product_Line__c",
            label: "Product Line",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Reply_to_Email__c",
            label: "Reply to Email",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Requester_Email__c",
            label: "Submitter Email",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Requester_Name__c",
            label: "Requester Name",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "SuppliedEmail",
            label: "Web Email",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Origin",
            label: "Origin",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Page_URL__c",
            label: "Page URL",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Store_App_Key_Text__c",
            label: "App Key",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Chat_Group__c",
            label: "Chat Group",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Partner_Account__c",
            label: "agencyId",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Reply_To_Email__c",
            label: "Reply To Email",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Is_LT__c",
            label: "Is LT",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Is_HT__c",
            label: "Is HT",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Is_Free__c",
            label: "Is Free",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
        ],
      },
    ],
  },
  case_2: {
    prechatDetails: [
      {
        label: "Topic",
        value: "Please select",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "First Name",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Last Name",
        value: "Aviram",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Email",
        value: "aviram7168@gmail.com",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Product Line",
        value: "SMS",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "Reply to Email",
        value: "aviram7168@gmail.com",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Submitter Email",
        value: "aviram7168@gmail.com",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Requester Name",
        value: "Aviram",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Web Email",
        value: "aviram7168@gmail.com",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true,
        doKnowledgeSearch: false,
      },
      {
        label: "Is HT",
        value: false,
        entityMaps: [],
        transcriptFields: ["Is_HT__C"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "Is LT",
        value: true,
        entityMaps: [],
        transcriptFields: ["Is_LT__C"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "Is Free",
        value: true,
        entityMaps: [],
        transcriptFields: ["Is_Free__c"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "Origin",
        value: "Live Chat",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "App Key",
        value: "10s3u7Www6MgonmagjIK3HznfKq2O5yv5XCn8ny9",
        entityMaps: [],
        transcriptFields: ["App_Key__c"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "Chat Group",
        value: "UGC Growth",
        entityMaps: [],
        transcriptFields: ["Chat_Group__c"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "agencyId",
        entityMaps: [],
        transcriptFields: ["Partner_Account__c"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "Page URL",
        value: "https://email-and-sms.yotpo.com/",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "CTTopic",
        entityMaps: [],
        transcriptFields: ["Topic__c"],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "eswLiveAgentDevName",
        value: "EmbeddedServiceLiveAgent_Parent04I3W0000004C9wUAE_17bc8e835e7",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
      {
        label: "hasOnlyExtraPrechatInfo",
        value: false,
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: false,
        doKnowledgeSearch: false,
      },
    ],
    prechatEntities: [
      {
        entityName: "Contact",
        showOnCreate: true,
        linkToEntityName: "Case",
        linkToEntityField: "ContactId",
        saveToTranscript: "ContactId",
        entityFieldsMaps: [
          {
            fieldName: "FirstName",
            label: "First Name",
            doFind: true,
            isExactMatch: true,
            doCreate: false,
          },
          {
            fieldName: "LastName",
            label: "Last Name",
            doFind: true,
            isExactMatch: true,
            doCreate: false,
          },
          {
            fieldName: "Email",
            label: "Email",
            doFind: true,
            isExactMatch: true,
            doCreate: false,
          },
        ],
      },
      {
        entityName: "Case",
        showOnCreate: true,
        saveToTranscript: "CaseId",
        entityFieldsMaps: [
          {
            fieldName: "Topic__c",
            label: "Topic",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Product_Line__c",
            label: "Product Line",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Reply_to_Email__c",
            label: "Reply to Email",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Requester_Email__c",
            label: "Submitter Email",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Requester_Name__c",
            label: "Requester Name",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "SuppliedEmail",
            label: "Web Email",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Origin",
            label: "Origin",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Page_URL__c",
            label: "Page URL",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Store_App_Key_Text__c",
            label: "App Key",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Chat_Group__c",
            label: "Chat Group",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Partner_Account__c",
            label: "agencyId",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Reply_To_Email__c",
            label: "Reply To Email",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Is_LT__c",
            label: "Is LT",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Is_HT__c",
            label: "Is HT",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
          {
            fieldName: "Is_Free__c",
            label: "Is Free",
            doFind: false,
            isExactMatch: false,
            doCreate: true,
          },
        ],
      },
    ],
  },
};
